import React, { Component } from 'react';
import { ErrorMessage } from 'formik';
import Input from '../../../../../components/Input/input.component';
import {
	CEPMask, CNPJMask, phoneMask,
} from '../../../../../components/Input/Masks';
import Required from '../../../../../components/Required/required.component';
import SelectMulti from '../../../../../components/SelectMulti/selectmulti.component';
import municipioService from '../../../../../services/municipioService';
import Subtitle from '../../../../../components/Subtitle/subtitle.component';

export default class EditarEmpresa extends Component {
	constructor(props) {
		super(props);
		this.state = {
			municipios: [],
			empresaSelecionada: {
				nome: '',
				cnpj: '',
				email: '',
				telefonePrincipal: '',
				telefoneSecundario: '',
				endereco: {
					municipio: '',
					cep: '',
					bairro: '',
					logradouro: '',
					numero: '',
					complemento: '',
				},
			},
		};
	}

	async componentDidMount() {
		const responseMunicipio = await municipioService.findAll();
		this.setState({ municipios: [...responseMunicipio.data] });

		const { empresa, setFieldValue } = this.props;
		if (empresa !== null) {
			this.setState({
				empresaSelecionada: {
					...empresa,
					telefonePrincipal: empresa.telefonePrincipal
						? this.formatarTelefone(empresa.telefonePrincipal) : empresa.telefonePrincipal,
					telefoneSecundario: empresa.telefoneSecundario
						? this.formatarTelefone(empresa.telefoneSecundario) : empresa.telefoneSecundario,
				},
			});
		}
		const { empresaSelecionada } = this.state;
		setFieldValue('destinoEstoque.empresa', empresaSelecionada);
	}

	formatarTelefone = (telefone) => {
		if (!telefone) return '--';
		// eslint-disable-next-line no-useless-escape
		const telefoneEdit = telefone.replace(/[^\d\+]/g, '');
		const isFixo = telefoneEdit.length === 10;
		const posicaoTraco = isFixo ? 6 : 7;
		return `(${telefoneEdit.slice(0, 2)}) ${telefoneEdit.slice(2, posicaoTraco)}-${telefoneEdit.slice(posicaoTraco)}`;
	}

	render() {
		const {
			props: {
				handleChange,
				setFieldValue,
				empresa,
			},
			state: {
				municipios,
			},
		} = this;

		return (
			<React.Fragment>
				<div className='row'>
					<div className='col-md-12'>
						<div className='mb-2'>
							<Subtitle>Dados da Empresa</Subtitle>
						</div>
						<label>
							Empresa: <Required />
						</label>
						<div className='form-group'>
							<Input
								type='input'
								name='destinoEstoque.empresa.nome'
								onChange={(e) => {
									handleChange(e);
								}}
								value={empresa ? empresa.nome : ''}
							/>
							<ErrorMessage
								name='destinoEstoque.empresa.nome'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
				</div>

				<div className='row'>
					<div className='col-md-4'>
						<label>
							CNPJ: <Required />
						</label>
						<div className='form-group'>
							<Input
								placeholder='00.000.000/0000-00'
								mask={CNPJMask}
								type='text'
								name='destinoEstoque.empresa.cnpj'
								onChange={(e) => {
									handleChange(e);
								}}
								value={empresa ? empresa.cnpj : ''}
							/>
							<ErrorMessage
								name='destinoEstoque.empresa.cnpj'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
					<div className='col-md-8'>
						<label>
							Município: <Required />
						</label>
						<div className='form-group'>
							<SelectMulti
								isClearable={false}
								isMulti={false}
								name='destinoEstoque.empresa.endereco.municipio'
								uniqueKey='codigoIbge'
								label='nome'
								value={empresa && empresa.endereco ? empresa.endereco.municipio : ''}
								onChange={(item) => {
									setFieldValue('destinoEstoque.empresa.endereco.municipio', item.object);
								}}
								options={municipios}
							/>
							<ErrorMessage
								name='destinoEstoque.empresa.endereco.municipio'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
				</div>

				<div className='row'>
					<div className='col-md-12'>
						<label>
							E-mail: <Required />
						</label>
						<div className='form-group'>
							<Input
								type='input'
								name='destinoEstoque.empresa.email'
								onChange={(e) => {
									handleChange(e);
								}}
								value={empresa ? empresa.email : ''}
							/>
							<ErrorMessage
								name='destinoEstoque.empresa.email'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
				</div>
				<div className='row'>
					<div className='col-md-6'>
						<label>
							Telefone: <Required />
						</label>
						<div className='form-group'>
							<Input
								placeholder='(00) 0 0000-0000'
								mask={phoneMask}
								type='input'
								name='destinoEstoque.empresa.telefonePrincipal'
								onChange={(value) => {
									const result = value.target.value.replace(
										/\D/g,
										'',
									);
									setFieldValue(
										'destinoEstoque.empresa.telefonePrincipal',
										result,
									);
								}}
								value={empresa ? empresa.telefonePrincipal : ''}
							/>
							<ErrorMessage
								name='destinoEstoque.empresa.telefonePrincipal'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
					<div className='col-md-6'>
						<label>Telefone secundário:</label>
						<div className='form-group'>
							<Input
								placeholder='(00) 0 0000-0000'
								mask={phoneMask}
								type='input'
								name='destinoEstoque.empresa.telefoneSecundario'
								onChange={(value) => {
									const result = value.target.value.replace(
										/\D/g,
										'',
									);
									setFieldValue(
										'destinoEstoque.empresa.telefoneSecundario',
										result,
									);
								}}
								value={empresa ? empresa.telefoneSecundario : ''}
							/>
							<ErrorMessage
								name='destinoEstoque.empresa.telefoneSecundario'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
				</div>
				<div className='row'>
					<div className='col-md-4'>
						<label>
							CEP: <Required />
						</label>
						<div className='form-group'>
							<Input
								placeholder='00.000-000'
								mask={CEPMask}
								type='input'
								name='destinoEstoque.empresa.endereco.cep'
								onChange={(e) => {
									handleChange(e);
								}}
								value={empresa ? empresa.endereco.cep : ''}
							/>
							<ErrorMessage
								name='destinoEstoque.empresa.endereco.cep'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
					<div className='col-md-8'>
						<label>
							Bairro: <Required />
						</label>
						<div className='form-group'>
							<Input
								type='input'
								name='destinoEstoque.empresa.endereco.bairro'
								onChange={(e) => {
									handleChange(e);
								}}
								value={empresa ? empresa.endereco.bairro : ''}
							/>
							<ErrorMessage
								name='destinoEstoque.empresa.endereco.bairro'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
				</div>
				<div className='row'>
					<div className='col-md-12'>
						<label>
							Logradouro: <Required />
						</label>
						<div className='form-group'>
							<Input
								type='input'
								name='destinoEstoque.empresa.endereco.logradouro'
								onChange={(e) => {
									handleChange(e);
								}}
								value={empresa ? empresa.endereco.logradouro : ''}
							/>
							<ErrorMessage
								name='destinoEstoque.empresa.endereco.logradouro'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
				</div>
				<div className='row'>
					<div className='col-md-6'>
						<label>
							Número: <Required />
						</label>
						<div className='form-group'>
							<Input
								type='input'
								name='destinoEstoque.empresa.endereco.numero'
								onChange={(e) => {
									handleChange(e);
								}}
								value={empresa ? empresa.endereco.numero : ''}
							/>
							<ErrorMessage
								name='destinoEstoque.empresa.endereco.numero'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
					<div className='col-md-6'>
						<label>Complemento:</label>
						<div className='form-group'>
							<Input
								type='input'
								name='destinoEstoque.empresa.endereco.complemento'
								onChange={(e) => {
									handleChange(e);
								}}
								value={empresa ? empresa.endereco.complemento : ''}
							/>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}
